import { Injectable } from '@angular/core';

@Injectable()
export class Constants {

  private _limitWarningPercent = 200;

  private _automateFilterTypes = {
    source: new AutomateFilterType('source'),
    body: new AutomateFilterType('body'),
    subject: new AutomateFilterType('subject'),
    emailType: new AutomateFilterType('email_type'),
    language: new AutomateFilterType('language'),
    confidence: new AutomateFilterType('confidence'),
    header: new AutomateFilterType('header')
  }

  private _emailTypes: EmailType[] = [
    new EmailType('all', 'All Types', true, false, false, false, false, false, 'All email types processed by Drift Email', 'category-3'),
    new EmailType('general', 'Out of Office', true, true, true, true, true, true, 'Generic out of office emails with no reason provided', 'category-1'),
    new EmailType('vacation', 'Vacation', true, true, true, true, true, true, 'An out of office email providing vacation as a reason', 'category-1'),
    new EmailType('human', 'Human Reply', true, true, true, true, true, false, 'A non-automated reply written by an actual person', 'category-1'),
    new EmailType('humandirect', 'Human Direct', true, true, true, true, true, false, 'A direct email writen by an actual person', 'category-1'),
    new EmailType('left', 'Left Company', true, true, true, true, true, true, 'The recipient has left the company', 'category-2'),
    new EmailType('changed', 'Changed', true, true, true, true, true, true, 'The contact\'s email address has changed', 'category-2'),
    new EmailType('unsubscribe', 'Unsubscribe', true, true, true, false, true, false, 'A human response requesting an unsubscribe from future emails', 'category-3'),
    new EmailType('bounce', 'Bounce', true, true, true, false, true, true, 'Emails that were rejected by the contact\'s mail server', 'category-3'),
    new EmailType('system', 'System', true, true, true, false, true, true, 'Automated replies that appear to have come from an unmonitored email account', 'category-3'),
    new EmailType('spamshield', 'Spam Shield', true, true, true, false, true, true, 'The contact\'s email is protected by a 3rd-party blocking utility', 'category-3'),
    new EmailType('unknown', 'Unknown', true, true, false, true, true, false, 'Drift Email could not determine the type due to language or length of email', 'category-4'),
    new EmailType('notification', 'Notification', false, false, true, false, false, false, '', 'category-3'),
    new EmailType('spam', 'Spam', true, false, true, false, true, false, '', 'category-3')
  ]

  private _partners: Partner[] = [
    new Partner('acton', 'Act-On', true, true),
    new Partner('eloqua', 'Eloqua', true, true),
    new Partner('hubspot', 'HubSpot', true, true),
    new Partner('marketo', 'Marketo', true, true),
    new Partner('pardot', 'Pardot', true, true),
    new Partner('drift', 'Drift', false, true)
  ];

  private _contactQualities: ContactQuality[] = [
    new ContactQuality(0, 'All Qualities'),
    new ContactQuality(1, 'High Quality'),
    new ContactQuality(2, 'Medium Quality'),
    new ContactQuality(3, 'Low Quality')
  ];

  private _staticDates: StaticDate[] = [
    new StaticDate(1, 'Today'),
    new StaticDate(7, 'Last 7 days'),
    new StaticDate(30, 'Last 30 days'),
    new StaticDate(90, 'Last 90 days'),
    new StaticDate(1500, 'All time')
  ];

  private _siftrockFields: SiftrockField[] = [
    new SiftrockField('siftrock.companyDomain', 'Company Domain', 'string', false, false),
    new SiftrockField('siftrock.contactCard', 'Contact Card', 'string', false, false, false, true),
    new SiftrockField('siftrock.contactEmail', 'Contact Email Address', 'string', true, false),
    new SiftrockField('siftrock.contactFN', 'Contact First Name', 'string', true, false),
    new SiftrockField('siftrock.contactLN', 'Contact Last Name', 'string', true, false),
    new SiftrockField('siftrock.contactName', 'Contact Full Name', 'string', true, false),
    new SiftrockField('siftrock.contactPhone', 'Contact Phone Number', 'string', true, false),
    new SiftrockField('siftrock.contactTitle', 'Contact Title', 'string', true, false), // note! change isCore to true once other integrations aren't whack
    new SiftrockField('siftrock.replyDate', 'Date of the reply', 'datetime', false, false),
    new SiftrockField('siftrock.subject', 'Email subject', 'string', false, false),
    new SiftrockField('siftrock.firstDate', 'First date from reply body', 'datetime', false, false),
    new SiftrockField('siftrock.lastDate', 'Last date from reply body', 'datetime', false, false),
    new SiftrockField('siftrock.sentFrom', 'Source email address', 'string', false, true),
    new SiftrockField('siftrock.contactQuality', 'Quality of contact', 'string', false, false, true),
    new SiftrockField('siftrock.originalRecipient', 'Sender\'s email address', 'string', false, true),
    new SiftrockField('siftrock.originalRecipientFN', 'Sender\'s first name', 'string', false, false),
    new SiftrockField('siftrock.originalRecipientLN', 'Sender\'s last name', 'string', false, false),
    new SiftrockField('siftrock.originalRecipientFullName', 'Sender\'s full name', 'string', false, false),
    new SiftrockField('siftrock.replyType', 'Drift Email reply type', 'string', false, false),
    new SiftrockField('siftrock.Url', 'Drift Email Url', 'string', false, false),
    new SiftrockField('siftrock.replyText', 'Text from the reply', 'string', false, true)
  ];

  private _entityTypes: EntityType[] = [
    new EntityType('city', 'Cities'),
    new EntityType('fn', 'First Names'),
    new EntityType('ln', 'Last Names'),
    new EntityType('title', 'Titles'),
    new EntityType('stopwords_name', 'Stopwords (name)')
  ];

  private _languages: Language[] = [
    new Language('en', 'English', true),
    new Language('da', 'Danish'),
    new Language('nl', 'Dutch'),
    new Language('fi', 'Finnish'),
    new Language('fr', 'French', true),
    new Language('de', 'German', true),
    new Language('el', 'Greek'),
    new Language('is', 'Icelandic'),
    new Language('it', 'Italian'),
    new Language('no', 'Norwegian'),
    new Language('pl', 'Polish'),
    new Language('pt', 'Portuguese'),
    new Language('ro', 'Romanian'),
    new Language('sk', 'Slovak'),
    new Language('es', 'Spanish', true),
    new Language('tr', 'Turkish'),
    new Language('uk', 'Ukranian')
  ];

  /**
   * These are fields we don't want to show in the UI as options either because we are automatically
   * mapping them or they are invalid for create/update
   */
  private _systemFields: SystemField[] = [
    new SystemField('eloqua', 'First Name'),
    new SystemField('eloqua', 'Last Name'),
    new SystemField('eloqua', 'Email Address'),
    new SystemField('eloqua', 'Business Phone'),
    new SystemField('hubspot', 'firstname'),
    new SystemField('hubspot', 'lastname'),
    new SystemField('hubspot', 'email'),
    new SystemField('hubspot', 'phone'),
    new SystemField('marketo', 'firstName'),
    new SystemField('marketo', 'id'),
    new SystemField('marketo', 'middleName'),
    new SystemField('marketo', 'lastName'),
    new SystemField('marketo', 'firstName'),
    new SystemField('marketo', 'email'),
    new SystemField('marketo', 'phone'),
    new SystemField('marketo', 'title'),
    new SystemField('pardot', 'email'),
    new SystemField('pardot', 'first_name'),
    new SystemField('pardot', 'last_name'),
    new SystemField('pardot', 'phone')
  ];

  /**
   * These are used to default workflow fields for display in the UI. For Pardot these actually get mapped in the workflow, for others
   * they are just for display purposes
   */
  private _coreFields: CoreField[] = [
    new CoreField('marketo', -1, 'email', 'Email Address', 'Contact Email Address', 'siftrock.contactEmail'),
    new CoreField('marketo', -1, 'firstName', 'First Name', 'Contact First Name', 'siftrock.contactFN'),
    new CoreField('marketo', -1, 'lastName', 'Last Name', 'Contact Last Name', 'siftrock.contactLN'),
    new CoreField('marketo', -1, 'phone', 'Phone Number', 'Contact Phone Number', 'siftrock.contactPhone'),
    new CoreField('marketo', -1, 'title', 'Job Title', 'Contact Job Title', 'siftrock.contactTitle'),
    new CoreField('eloqua', -1, 'Email Address', 'Email Address', 'Contact Email Address', 'siftrock.contactEmail'),
    new CoreField('eloqua', -1, 'First Name', 'First Name', 'Contact First Name', 'siftrock.contactFN'),
    new CoreField('eloqua', -1, 'Last Name', 'Last Name', 'Contact Last Name', 'siftrock.contactLN'),
    new CoreField('eloqua', -1, 'Business Phone', 'Phone Number', 'Contact Phone Number', 'siftrock.contactPhone'),
    new CoreField('eloqua', -1, 'Title', 'Job Title', 'Contact Job Title', 'siftrock.contactTitle'),
    new CoreField('hubspot', -1, 'email', 'Email Address', 'Contact Email Address', 'siftrock.contactEmail'),
    new CoreField('hubspot', -1, 'firstname', 'First Name', 'Contact First Name', 'siftrock.contactFN'),
    new CoreField('hubspot', -1, 'lastname', 'Last Name', 'Contact Last Name', 'siftrock.contactLN'),
    new CoreField('hubspot', -1, 'phone', 'Phone Number', 'Contact Phone Number', 'siftrock.contactPhone'),
    new CoreField('hubspot', -1, 'jobtitle', 'Job Title', 'Contact Job Title', 'siftrock.contactTitle'),
    new CoreField('pardot', -1, 'email', 'Email Address', 'Contact Email Address', 'siftrock.contactEmail'),
    new CoreField('pardot', -1, 'first_name', 'First Name', 'Contact First Name', 'siftrock.contactFN'),
    new CoreField('pardot', -1, 'last_name', 'Last Name', 'Contact Last Name', 'siftrock.contactLN'),
    new CoreField('pardot', -1, 'phone', 'Phone Number', 'Contact Phone Number', 'siftrock.contactPhone'),
    new CoreField('pardot', -1, 'job_title', 'Job Title', 'Contact Job Title', 'siftrock.contactTitle')
  ];

  private _preTrialSku = new Sku('5806e439d54c2373c5fe8ec0', 'Pre-trial');
  private _freeTrialSku = new Sku('563290b8eb4d64d91f8a27c8', 'Free Trial');

  private _accountStatuses: AccountStatus[] = [
    new AccountStatus('active', 'Active', false),
    new AccountStatus('suspended', 'Suspended', true),
    new AccountStatus('deleted', 'Mark for Deletion', true)
  ];

  private _inboxStatuses: InboxStatus[] = [
    new InboxStatus('enabled', 'Active', true),
    new InboxStatus('disabled', 'Deleted', false)
  ];

  private _authStatuses: AuthStatus[] = [
    new AuthStatus('good', 'Good', 3),
    new AuthStatus('invited', 'Invited', 0),
    new AuthStatus('failing', 'Failing', 2)
  ];

  private _skuStatuses: SkuStatus[] = [

    new SkuStatus('complimentary', 'Complimentary', 'Complimentary'),
    new SkuStatus('paid', 'Paid', 'Paid Account'),
    new SkuStatus('paid sub', 'Paid - Sub', 'Paid Account - Sub'),
    new SkuStatus('free', 'Free Trial', 'Free Trial')
  ];

  private _botStatuses: BotStatus[] = [
    new BotStatus('human', 'Human', false),
    new BotStatus('bot', 'Bot', true)
  ];

  private _skillTypes =
    [
      new SkillType('routetrack', 'Route & Track'),
      new SkillType('updatecontacts', 'Update Contacts'),
      new SkillType('minedcontacts', 'Mined Contacts'),
      new SkillType('sendercontacts', 'Sender Contacts'),
      new SkillType('botevent', 'Bot Response & Track')
    ];

  private _taskTypes = {
    route: 'Route',
    track: 'Track',
    create: 'Create'
  };

  private _jobTypes: string[] = ['cdo', 'create', 'enrich', 'route', 'track'];

  constructor() { }

  get limitWarningPercent(): number {
    return this._limitWarningPercent;
  }

  get skillTypes() {
    return this._skillTypes;
  }

  get taskTypes() {
    return this._taskTypes;
  }

  get automateFilterTypes() {
    return this._automateFilterTypes;
  }

  get jobTypes(): string[] {
    return this._jobTypes;
  }

  get emailTypes(): EmailType[] {
    return this._emailTypes;
  }

  get partners(): Partner[] {
    return this._partners;
  }

  get contactQualities(): ContactQuality[] {
    return this._contactQualities;
  }

  get staticDates(): StaticDate[] {
    return this._staticDates;
  }

  get siftrockFields(): SiftrockField[] {
    return this._siftrockFields;
  }

  get entityTypes(): EntityType[] {
    return this._entityTypes;
  }

  get languages(): Language[] {
    return this._languages;
  }

  get systemFields(): SystemField[] {
    return this._systemFields;
  }

  get coreFields(): CoreField[] {
    return this._coreFields;
  }

  get accountStatuses(): AccountStatus[] {
    return this._accountStatuses;
  }

  get inboxStatuses(): InboxStatus[] {
    return this._inboxStatuses;
  }

  get authStatuses(): AuthStatus[] {
    return this._authStatuses;
  }

  get skuStatuses(): SkuStatus[] {
    return this._skuStatuses;
  }

  get botStatuses(): BotStatus[] {
    return this._botStatuses;
  }

  get preTrialSku(): Sku {
    return this._preTrialSku;
  }

  get freeTrialSku(): Sku {
    return this._freeTrialSku;
  }
}

export class Sku {
  constructor(public id: string,
    public name: string) { }
}

export class AutomateFilterType {
  constructor(public name: string) { }
  toString() { return this.name }
}

export class EmailType {
  constructor(public typeName: string,
    public display: string,
    public includeInFilters: boolean,
    public includeInWorkflows: boolean,
    public includeInTraining: boolean,
    public hasContacts: boolean,
    public includeGoldenset: boolean,
    public nbType: boolean,
    public description: string,
    public cssClass: string,
    ) { }
}

export class Partner {
  constructor(public name: string,
    public display: string,
    public hasLists: boolean,
    public hasFields: boolean) { }
}

export class ContactQuality {
  constructor(public quality: number,
    public display: string) { }
}

export class StaticDate {
  constructor(public numDays: number,
    public display: string) { }
}

export class SiftrockField {
  constructor(public fieldName: string,
    public display: string,
    public type: string,
    public isCore: boolean,
    public includeInFilters: boolean,
    public trackTask: boolean = true,
    public cdoOnly: boolean = false,
    public used: boolean = false
  ) { }
}

export class EntityType {
  constructor(public name: string,
    public display: string) { }
}

export class Language {
  constructor(public name: string,
    public display: string,
    public supported: boolean = false) { }
}

export class AccountStatus {
  constructor(public name: string,
    public display: string,
    public userLock: boolean) { }
}

export class InboxStatus {
  constructor(public name: string,
    public display: string,
    public value: boolean) { }
}

export class AuthStatus {
  constructor(public name: string,
    public display: string,
    public value: number) { }
}

export class SkuStatus {
  constructor(public name: string,
    public display: string,
    public value: string) { }
}

export class BotStatus {
  constructor(public name: string,
    public display: string,
    public value: boolean) { }
}

export class SystemField {
  constructor(public partner: string,
    public name: string) { }
}

export class CoreField {
  constructor(public partner: string,
    public id: number,
    public name: string,
    public description: string,
    public siftrockDescription: string,
    public value: string) { }
}

export class SkillType {
  constructor(
    public id: string,
    public name: string
  ) { }
}



// WEBPACK FOOTER //
// ./client/app/global/constants.ts